import { SelectionItem } from "../controls/Autocomplete"
import { EMBEDDING_MODELS_CATALOG, LLMProvider, PDF_READ_METHOD_LABELS, PDF_READ_METHODS, PdfReadMethod } from "./types"

export const selectionItems = (items: string[]): SelectionItem[] => {
    return items.map(item => ({ value: item, label: item }))
}

export const pdfReadMethodItems = (unlockPdfReadMethods: boolean, showVision: boolean = false): SelectionItem[] => {
    return PDF_READ_METHODS.filter(method => showVision || method !== 'vision').map(method => (
        { value: method, 
        label: PDF_READ_METHOD_LABELS[method], 
        disabled: method === 'vision' || (!unlockPdfReadMethods && method === 'msr_vision') }))
}

export const embeddingModelItems = (pdfReadMethod: PdfReadMethod, provider: LLMProvider = 'OpenAI'): SelectionItem[] => {
    if (pdfReadMethod in EMBEDDING_MODELS_CATALOG && provider in EMBEDDING_MODELS_CATALOG[pdfReadMethod]) {
        return EMBEDDING_MODELS_CATALOG[pdfReadMethod][provider].map(model => ({ value: model, label: model }))
    }
    return []
}

